import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	

//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [wptapp, setWptapp] = useState({});


const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "Remove Application";	

if (location.state!=null)
	if (location.state.wptapp!=undefined){
		setWptapp(location.state.wptapp);
		setWptapp((prev)=>{
			return {...prev, NEW_STATUS:""}
			});
		}//end if
		

 },[]);


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

	
async function removeappfromlist(e){
	e.preventDefault();
	
	if (wptapp.CANCEL_DATE!=null)
		if (wptapp.CANCEL_DATE!=""){
			window.alert("Cancelled already");
			return;
			}

	if (wptapp.NEW_STATUS=="CANCELLED" && wptapp.STATUS!="NOTSUBMIT"){
		window.alert("Only applications that are not submitted can be cancelled");
		return;
		}//end if
	
	const result=await window.confirm("This application will be removed from the list.  Are you sure?");
	
	if (!result)
		return;
	
	const params={
		USERNAME: sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, STATUS: wptapp.NEW_STATUS
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/update_wptapp_status',requestOptions)
      .then(res => res.json())
      .then(res => 	afterremoveappfromlist(res) )	
	
}//end func


function afterremoveappfromlist(res){
	const UPDATE_COUNT = res.length?(res[0].UPDATE_COUNT??0):0;
	if (UPDATE_COUNT==0)
		window.alert("update failed! try again or contact admin");
	else{
		showsnackbar("done!");
		setWptapp((prev)=>{
			return {...prev, NEW_STATUS:"", STATUS:res[0].STATUS??""}
			});
		}//end else
		
}//end func

function handleChange(e){
const {name, value}=e.target;
	setWptapp((prev) => {
	return {...prev, [name]:value}
	});
}//end func


  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Remove Application from List</p>	
	
	<table align='center'>
	<tbody>

	<tr>
	<td align='right' >APS Id #: </td>
	<td align='left' >{wptapp.WPT_APP_ID}</td>
	</tr>
	<tr>
	<td align='right' >Applicantion Ref: </td>
	<td align='left' >{wptapp.REF_NUM}</td>
	</tr>
	<tr>
	<td align='right' >Date Submitted: </td>
	<td align='left' >{wptapp.CHR_SUBMITTED_TO_CSC}</td>
	</tr>	
	<tr>
	<td align='right' >Created By: </td>
	<td align='left' >{wptapp.EMAIL_TO}</td>
	</tr>	
	
	<tr>
	<td align='right' >Employer's Last Name: </td>
	<td align='left' >{wptapp.MPR_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's First Name: </td>
	<td align='left' >{wptapp.MPE_FIRST_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's Last Name: </td>
	<td align='left' >{wptapp.MPE_LAST_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's Immig. Ref: </td>
	<td align='left' >{wptapp.IMG_REF}</td>
	</tr>
	<tr>
	<td align='right' >Job Title: </td>
	<td align='left' >{wptapp.MPE_OCCUPATION}</td>
	</tr>
	<tr>
	<td align='right' >Status: </td>
	<td align='left' >{wptapp.STATUS}</td>
	</tr>

	<tr>
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptform", {state:{WPT_APP_ID:wptapp.WPT_APP_ID}});  }}  >return to application</a></td>
	<td align='left' >
	{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && wptapp.NEW_STATUS!="" &&
	<button className='button' id='btnsave'  onClick={(e)=>{removeappfromlist(e);}}  >update application status</button>
	}	
	
	</td>
	</tr>
	{
	wptapp.STATUS!="MANWRITEOFF" &&
	<tr>
	<td align='right' >New Status: </td>
	<td align='left' >
		<select name="NEW_STATUS" value={wptapp.NEW_STATUS} onChange={(e)=>{handleChange(e);}} >
		<option key="opt0" value="" ></option>
		<option key="opt1" value="CANCELLED" >Cancelled</option>
		<option key="opt2" value="MANWRITEOFF" >Manually Written Off</option>
		</select>
	</td>
	</tr>
	}

	</tbody>
	</table>
	



<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;